var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-autocomplete",
    _vm._b(
      {
        attrs: {
          "error-messages": _vm.$utils.getIfExists(_vm.errorMessages, [
            "messages",
          ]),
          "search-input": _vm.input,
          label: _vm.label,
          hint: _vm.hint,
          "persistent-hint": _vm.hint ? true : false,
          suffix: _vm.suffix,
          items: _vm.items,
          "item-text": "name",
          "item-value": "id",
          loading: _vm.isLoading,
          readonly: _vm.readonly,
          "no-data-text": "No profiles found",
        },
        on: {
          "update:searchInput": function ($event) {
            _vm.input = $event
          },
          "update:search-input": function ($event) {
            _vm.input = $event
          },
        },
        scopedSlots: _vm._u(
          [
            {
              key: "item",
              fn: function (ref) {
                var item = ref.item
                return [
                  _c(
                    "v-list-item-content",
                    [
                      _c("v-list-item-title", [_vm._v(_vm._s(item.name))]),
                      item.updated
                        ? _c("v-list-item-subtitle", [
                            _vm._v(
                              " Created: " +
                                _vm._s(_vm._f("dateToString")(item.updated)) +
                                " "
                            ),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                  item != null
                    ? _c(
                        "v-list-item-action",
                        [
                          _c(
                            "v-card",
                            {
                              staticClass: "d-flex",
                              attrs: { color: "transparent", flat: "" },
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: { icon: "" },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.downloadProfile(item)
                                    },
                                  },
                                },
                                [_c("v-icon", [_vm._v("mdi-download")])],
                                1
                              ),
                              _c(
                                "v-btn",
                                {
                                  attrs: { icon: "" },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.removeProfile(item.id)
                                    },
                                  },
                                },
                                [_c("v-icon", [_vm._v("delete")])],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ]
              },
            },
            _vm.input && !_vm.hideUpload
              ? {
                  key: "no-data",
                  fn: function () {
                    return [
                      _c("InputCSV", {
                        attrs: { onComplete: _vm.processProfile },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "activator",
                              fn: function (ref) {
                                var triggerUpload = ref.triggerUpload
                                return [
                                  _c(
                                    "v-list-item",
                                    { on: { click: triggerUpload } },
                                    [
                                      _c("v-list-item-title", [
                                        _vm._v(" Upload new profile: "),
                                        _c("strong", [
                                          _vm._v(_vm._s(_vm.input)),
                                        ]),
                                      ]),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          739699568
                        ),
                      }),
                    ]
                  },
                  proxy: true,
                }
              : null,
          ],
          null,
          true
        ),
        model: {
          value: _vm.model,
          callback: function ($$v) {
            _vm.model = $$v
          },
          expression: "model",
        },
      },
      "v-autocomplete",
      _vm.$attrs,
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }